import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/seo/Seo";

export default function NotFound() {
  return (
    <main className="min-h-[70vh] flex items-center" data-testid="not-found-page">
      <Seo title="Page not found" noindex />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-32">
        <p className="eyebrow text-[var(--terracotta)]">404</p>
        <h1 className="font-display font-normal text-4xl sm:text-5xl mt-4 text-[var(--ink)]">We couldn't find that page</h1>
        <p className="mt-6 text-[var(--charcoal)] font-light max-w-lg">The range or page you're after may have moved. Browse the full wholesale range or get in touch with our Sydney team.</p>
        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/brands" className="btn-pill btn-ink">Browse the range <ArrowRight size={14} /></Link>
          <Link to="/contact" className="btn-pill btn-outline">Contact us</Link>
        </div>
      </div>
    </main>
  );
}
